import React, { useState, useEffect } from "react";
import Translator, { __ } from "services/Translator";
import { Dropdown } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import api from "services/api";
import { Helmet } from "react-helmet";
import config from "configs/config.js";

export default function LanguageSwitcherAccordion(props) {
  const history = useHistory();
  const [languages, setLanguages] = useState([]);
  const selectedLanguage = Translator.getSelectedLanguage();
  const [appUrl, setAppUrl] = useState(config.appUrl);
  const getLanguages = async () => {
    var response = await api.get("/languages");
    if (response.status === 200) {
      // setLanguages(
      //   response.data.map((val) => {
      //     return { label: val.language, value: val.code };
      //   })
      // );
      setLanguages(response.data);
    } else {
      props.showAlert("Warning!!", response.data.message);
    }
  };

  const switchLanguage = (lang) => {
    // var homeUrl = history.createHref({ pathname: "/" });
    // var currentUrl = window.location.href;
    // var newUrl = currentUrl.replace(homeUrl, "/" + lang.code + "/");
    Translator.setSelectedLanguage(lang);
    // window.location.href = newUrl;
    window.location.reload();
  };

  useEffect(() => {
    getLanguages();
  }, []);

  return (
    <>
      <Helmet>
        {languages.length > 0 &&
          languages.map((value, index) => (
            <link
              rel="alternate"
              hreflang={value.code + "-" + value.countries}
              href={appUrl + "/" + value.code}
            />
          ))}
      </Helmet>
      <div className="languageSwitcherAccordion">
        <div className="accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2
              className="accordion-header accordionBtnStyle"
              id="flush-headingOne"
            >
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                <div className="icon">
                  <svg width="29" height="15" viewBox="0 0 29 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.8916 6.32393C6.74368 5.81287 6.56317 4.94597 6.54074 4.83744C6.53937 4.83082 6.53357 4.82617 6.52681 4.82617C6.52005 4.82617 6.51424 4.83083 6.51288 4.83745C6.49056 4.94604 6.31101 5.81289 6.16201 6.32393L5.90561 7.1863C5.78256 7.60018 6.09264 8.01587 6.52443 8.01587C6.95486 8.01587 7.26475 7.60262 7.14417 7.18943L6.8916 6.32393ZM27.9126 2.48542e-06H19.2249C17.0158 2.48542e-06 15.2249 1.79086 15.2249 4V10.4335C15.2249 12.6426 17.0158 14.4335 19.2249 14.4335H27.9114C28.0543 14.4339 28.1959 14.4063 28.328 14.3521C28.4601 14.298 28.5802 14.2184 28.6814 14.1179C28.7825 14.0175 28.8627 13.8981 28.9174 13.7667C28.9721 13.6353 29.0002 13.4944 29 13.3521V1.08135C29.0002 0.939209 28.9721 0.798408 28.9175 0.667068C28.8629 0.535728 28.7828 0.416417 28.6818 0.315959C28.5808 0.2155 28.4608 0.135895 28.3288 0.0816739C28.1968 0.0274528 28.0554 -0.000301977 27.9126 2.48542e-06ZM26.8252 5.41255C26.8246 5.55591 26.7671 5.69321 26.6653 5.79458C26.5634 5.89595 26.4255 5.95322 26.2815 5.95383C25.975 5.95383 25.7087 6.15735 25.5963 6.44247C25.3906 6.96401 25.1021 7.48549 24.7396 7.99879C24.2967 8.6259 24.3574 9.51983 25.0128 9.91951C25.1324 9.99375 25.2186 10.1112 25.2532 10.2472C25.2879 10.3832 25.2683 10.5273 25.1987 10.6493L24.8397 11.2773C24.8034 11.3399 24.7549 11.3946 24.697 11.4383C24.6392 11.482 24.5732 11.5137 24.5029 11.5317C24.4326 11.5497 24.3594 11.5535 24.2875 11.543C24.2157 11.5325 24.1467 11.5078 24.0846 11.4704C23.1057 10.8733 21.8541 10.8723 20.8758 11.4704C20.8136 11.5082 20.7444 11.5332 20.6723 11.5439C20.6002 11.5546 20.5267 11.5508 20.4561 11.5328C20.3855 11.5148 20.3193 11.483 20.2613 11.4391C20.2032 11.3952 20.1546 11.3402 20.1183 11.2773L19.7605 10.6493C19.6907 10.5269 19.6715 10.3822 19.7071 10.246C19.7427 10.1097 19.8302 9.99261 19.951 9.91951C20.6061 9.5189 20.6675 8.62628 20.22 8.00234C20.2069 7.98416 20.194 7.96595 20.181 7.94768C20.1387 7.88681 20.1094 7.81792 20.095 7.74531C20.0805 7.67269 20.0812 7.5979 20.097 7.52556C20.1128 7.45322 20.1433 7.38489 20.1868 7.32481C20.2302 7.26472 20.2856 7.21417 20.3495 7.17629L20.6446 7.00045L20.9745 6.80619C21.0929 6.73654 21.2332 6.71368 21.3677 6.74217C21.5022 6.77065 21.621 6.84841 21.7006 6.96C21.7507 7.02975 21.8024 7.0995 21.8559 7.1692C22.1777 7.58848 22.8424 7.53785 23.1587 7.11445C23.5596 6.57786 23.0983 5.95383 22.4285 5.95383H18.6696C18.5256 5.95322 18.3876 5.89595 18.2858 5.79458C18.184 5.69321 18.1265 5.55591 18.1259 5.41255V4.69085C18.1265 4.54749 18.184 4.4102 18.2858 4.30882C18.3876 4.20745 18.5256 4.15025 18.6696 4.14964H20.8477C21.2462 4.14964 21.5694 3.82653 21.5694 3.42794C21.57 3.28458 21.6274 3.14729 21.7293 3.04592C21.8311 2.94454 21.969 2.88728 22.1131 2.88667H22.8392C22.9832 2.88728 23.1211 2.94454 23.2229 3.04592C23.3248 3.14729 23.3823 3.28458 23.3829 3.42794C23.3829 3.82653 23.706 4.14964 24.1046 4.14964H26.2826C26.4266 4.15025 26.5646 4.20745 26.6664 4.30882C26.7682 4.4102 26.8257 4.54749 26.8263 4.69085L26.8252 5.41255ZM2.49316e-06 1.08248V13.3521C2.49316e-06 13.9512 0.48446 14.4347 1.08742 14.4347H9.7739C11.983 14.4347 13.7739 12.6438 13.7739 10.4347V4C13.7739 1.79086 11.983 2.48542e-06 9.7739 2.48542e-06H1.08742C0.944529 -0.000302431 0.802986 0.0274512 0.670917 0.0817445C0.538848 0.136038 0.418851 0.215801 0.317815 0.316382C0.216778 0.416963 0.136694 0.536441 0.0821545 0.667915C0.0276154 0.799389 -0.000303804 0.940241 2.49316e-06 1.08248ZM2.66858 10.8298L5.27442 3.20241C5.31106 3.09512 5.38073 3.00204 5.47355 2.93643C5.56636 2.87082 5.67758 2.83605 5.79141 2.83697H7.26336C7.49572 2.83697 7.70367 2.98614 7.78035 3.20241L10.385 10.8298C10.4126 10.9114 10.4204 10.9983 10.4076 11.0835C10.3948 11.1687 10.3619 11.2497 10.3115 11.3197C10.2611 11.3897 10.1947 11.4468 10.1178 11.4863C10.0409 11.5258 9.95572 11.5465 9.8692 11.5468H8.83175C8.71445 11.5469 8.60028 11.5092 8.50627 11.4394C8.41225 11.3695 8.34345 11.2713 8.31011 11.1593L8.26999 11.0236C8.04163 10.2509 7.33196 9.7206 6.5262 9.7206C5.71551 9.7206 5.00274 10.2573 4.77868 11.0364L4.74465 11.1547C4.7117 11.2673 4.64316 11.3664 4.54921 11.4372C4.45525 11.5081 4.34087 11.5469 4.22302 11.5479H3.18557C3.09903 11.5476 3.01381 11.5268 2.9369 11.4874C2.85999 11.4479 2.79358 11.3908 2.74313 11.3208C2.69267 11.2509 2.65961 11.17 2.64665 11.0848C2.63369 10.9996 2.6412 10.9115 2.66858 10.8298Z" fill="url(#paint0_linear_31_946)" />
                    <defs>
                      <linearGradient id="paint0_linear_31_946" x1="0" y1="7.21733" x2="29" y2="7.21733" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FBB040" />
                        <stop offset="1" stop-color="#956826" />
                      </linearGradient>
                    </defs>
                  </svg>

                </div>
                <div className="text">
                  {__("Language:")} {selectedLanguage.language}
                </div>
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#accordionFlushExample"
            >
              <ul className="languageItemLists">
                {languages.length > 0 &&
                  languages.map((value, index) => (
                    <li
                      onClick={() => switchLanguage(value)}
                      className={
                        selectedLanguage.code == value.code ? "selected" : ""
                      }
                    >
                      <label for={value.code} className="text fullName">
                        {value.alias ? value.alias : value.language}
                      </label>

                      <label for={value.code} className="text shortName">
                        {value.code}
                      </label>
                      <input
                        type="radio"
                        id={value.code}
                        defaultChecked={
                          selectedLanguage.code == value.code ? true : false
                        }
                        name="lang"
                      />
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
